import React from 'react';

import * as CONSTANTS from "../constants";
import * as OPTIONS from "../option-fields";

import IFrame from '../components/iframe';
import BasketUpsellBlock from '../components/basket-upsell';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/Basket2.aspx?resize=true`;

export default function IframeBasket() {

    return (
        <div className='booking-pathway__container booking-pathway__iframe-basket'>
            
            <div className='booking-pathway__main-content flex'>
                <h1 className='sr-text'>Basket</h1>

                <IFrame url={iframeURL} title="Basket" hasLoader="true" />
                <BasketUpsellBlock content={OPTIONS.BasketMembership} type="help-upsell" />

            </div>
        </div>
    );
}